import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            探索发现
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            按照你的兴趣方向，选择不同的内容分类开始学习
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}